<template>
  <div>
    <SectionTitle>Repeaters</SectionTitle>
    <PieChart :data="data" empty-message="No Repeaters" />
    <div class="text-center my-4">
      <BaseClearButton size="small" @click="goToNetworkPage">
        <i class="icon-eye mr-2 text-base"></i>
        View Repeaters
      </BaseClearButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import PieChart, { Datum } from '@/components/charts/PieChart.vue';
import BaseClearButton from '@/components/forms/BaseClearButton.vue';
import SectionTitle from '@/components/forms/SectionTitle.vue';
import { useSelectedProperty } from '@/stores/selected-property.store';
import { useIonRouter } from '@ionic/vue';
import { RepeaterRead } from '@ncss/models/dist/v3';
import { computed } from 'vue';

const router = useIonRouter();
const selectedProperty = useSelectedProperty();
const data = computed<Datum[]>(() => {
  const repeaters = selectedProperty.property?.repeaters;
  if (!repeaters?.length) {
    return [];
  }

  const stats = {
    online: 0,
    offline: 0,
    notInstalled: 0,
  };
  const checkInThreshold = RepeaterRead.GetOnlineThresholdDate();
  for (const r of repeaters) {
    if (!r.data?.lastCheckIn) {
      stats.notInstalled++;
    } else if (r.data.lastCheckIn > checkInThreshold) {
      stats.online++;
    } else {
      stats.offline++;
    }
  }
  return [
    { name: 'Online', value: stats.online, color: 'blue' },
    { name: 'Offline', value: stats.offline, color: 'red' },
    { name: 'Not Installed', value: stats.notInstalled, color: 'gray' },
  ];
});

function goToNetworkPage() {
  return router.push(`/network/${selectedProperty.propertyId}`);
}
</script>
